import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { createRuleAsync, deleteRuleAsync, getRuleAsync, getRuleByIdAsync, manualProcessRulesAsync } from './index';

const initialState = {
    isRuleLoading: false,
    isError: false,
    rules: [],
    totalCount: 0,
    rule: null,
    isRuleByIdLoading: false,
    isDeleteRuleLoading: false,
    isManualProcessRulesLoading: false
}

const ruleSlice = createSlice({
    name: 'rule',
    initialState,
    reducers: {
        handleResetRule: (state) => {
            state.rule = null;
            state.isRuleLoading = false;
            state.isRuleByIdLoading = false;
            state.isDeleteRuleLoading = false;
            state.rules = [];
            state.totalCount = 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRuleAsync.pending, (state) => {
                state.isRuleLoading = true;
            })
            .addCase(getRuleAsync.fulfilled, (state, { payload }) => {
                state.isRuleLoading = false;
                state.rules = payload.data?.rules?.length > 0 ? payload.data?.rules : [];
                state.totalCount = payload.data?.totalCount > 0 ? payload.data?.totalCount : 0;
            })
            .addCase(getRuleAsync.rejected, (state) => {
                state.isRuleLoading = false;
                state.isError = false;
                state.rules = [];
                state.totalCount = 0;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(createRuleAsync.pending, (state) => {
                state.isRuleLoading = true;
            })
            .addCase(createRuleAsync.fulfilled, (state) => {
                state.isRuleLoading = false;
            })
            .addCase(createRuleAsync.rejected, (state) => {
                state.isRuleLoading = false;
                state.isError = false;
            })
            .addCase(getRuleByIdAsync.pending, (state) => {
                state.isRuleByIdLoading = true;
            })
            .addCase(getRuleByIdAsync.fulfilled, (state, { payload }) => {
                state.isRuleByIdLoading = false;
                state.rule = payload;
            })
            .addCase(getRuleByIdAsync.rejected, (state) => {
                state.isRuleByIdLoading = false;
                state.isError = false;
                state.rule = null;
            })
            .addCase(deleteRuleAsync.pending, (state) => {
                state.isDeleteRuleLoading = true;
            })
            .addCase(deleteRuleAsync.fulfilled, (state) => {
                state.isDeleteRuleLoading = false;
            })
            .addCase(deleteRuleAsync.rejected, (state) => {
                state.isDeleteRuleLoading = false;
            })
            .addCase(manualProcessRulesAsync.pending, (state) => {
                state.isManualProcessRulesLoading = true
            })
            .addCase(manualProcessRulesAsync.fulfilled, (state) => {
                state.isManualProcessRulesLoading = false
            })
            .addCase(manualProcessRulesAsync.rejected, (state) => {
                state.isManualProcessRulesLoading = false
            })
    },
});

export const getAllRule = (state) => state.rule;
export const { handleResetRule } = ruleSlice.actions;
export default ruleSlice.reducer;
